export default {
	list: 'AllocationReport',
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
        },
        TaxYear: {
			class: "choice",
			dataName: 'TaxYear',
			type: 'string',
			title: 'Tax Year',
			width: 100,
			hidden: false,
			readOnly: false
		},
		TaxQuarter: {
			class: "choice",
			dataName: 'TaxQuarter',
			type: 'string',
			title: 'Tax Quarter',
			width: 100,
			hidden: false,
			readOnly: false
		},
		//made readonly as "false" to write to DB.json to test in local 
		//Although Calculated field works with SP also 
		TaxYearQuarter: {
			class: "value",
			dataName: 'TaxYearQuarter',
			type: 'string',
			title: 'Tax Period',
			width: 100,
			hidden: false,
			readOnly: false
		},
		ProgramId: {
			class: "lookup",
			dataName: 'ProgramId',
			type: 'number',
			title: 'ProgramId',
			width: 100,
			hidden: false,
			readOnly: false
        },
        ProgramTitle: {
			class: "lookup",
			dataName: 'Program/Title',
			type: 'string',
			title: 'Program Name',
			width: 200,
			hidden: false,
			readOnly: true
		},
		Status: {
			class: "value",
			dataName: 'Status',
			type: 'string',
			title: 'Status',
			width: 100,
			hidden: false,
			readOnly: false
		},
		AllocationDate: {
			class: 'value',
			dataName: 'Modified',
			type: 'date',
			title: 'Date',
			filterable: true,
			width: 100,
			hidden: false
		}
	},
}